import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-0d1f4b65"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "Playlist"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_PlayListHead = _resolveComponent("PlayListHead");

  var _component_PlayList = _resolveComponent("PlayList");

  var _component_Loading = _resolveComponent("Loading");

  var _component_Pagination = _resolveComponent("Pagination");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_PlayListHead, {
    ref: "listHead",
    listTag: _ctx.listTag,
    allTagList: _ctx.tagList,
    scrollTopTitle: "全部歌单",
    onChangeTagName: _ctx.changeTagName
  }, null, 8
  /* PROPS */
  , ["listTag", "allTagList", "onChangeTagName"]), _createCommentVNode(" 歌单列表区域 "), _ctx.isShow ? (_openBlock(), _createBlock(_component_PlayList, {
    key: 0,
    playList: _ctx.playList,
    total: _ctx.total,
    onChangeCurrent: _ctx.changeCurrent
  }, null, 8
  /* PROPS */
  , ["playList", "total", "onChangeCurrent"])) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createCommentVNode(" 歌单加载组件 "), _createVNode(_component_Loading)], 2112
  /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
  )), _createCommentVNode(" 分页数据 "), _createVNode(_component_Pagination, {
    total: _ctx.total,
    pageInfo: _ctx.pageInfo,
    curtPage: _ctx.curtPage,
    onChangeCurrent: _ctx.changeCurrent
  }, null, 8
  /* PROPS */
  , ["total", "pageInfo", "curtPage", "onChangeCurrent"])]);
}